import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ActivityIndicator } from "react-native-paper";
import { Platform } from "react-native";
import { signOutUser } from "../../redux/actions/actionCreators";
import { FullScreenLoader } from "../../components/new/loader/full-screen-loader";
import { translate } from "../../i18n";

export const ErrorBoundaryRender = ({ error, resetErrorBoundary }: any) => {
  const logger = useSelector((state) => state?.logger);
  const dispatch = useDispatch();

  //Will not use resetErrorBoundary to prevent infinit loops when retrying to re-render continues to throw a unhandled exception
  useEffect(() => {
    try {
      logger.error({ error, message: "App Crash" });
    } catch (e) {
      console.log(e);
    }
  }, []);

  //It is possible that we get a exception inside signOutUser in which case user will just see the generic meessage asking to restart/refresh the app/browser.
  dispatch(signOutUser());
  let deviceSpecificMessage = translate("errorBoundary.mobileRedirectMessage");
  if (Platform?.OS === "web") {
    deviceSpecificMessage = translate("errorBoundary.webRedirectMessage");
  }

  return (
    <>
      <FullScreenLoader
        loading={true}
        textLabel={translate("errorBoundary.redirectMessage", { deviceSpecificMessage })}
      />
    </>
  );
};
